import { useEffect } from 'react';
import { createPortal } from 'react-dom';

export function ModalThin(props) {
  const { children, header } = props;
  usePreventBodyScroll();
  return createPortal(
    <div
      className="relative z-20 modal-step"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto h-[100dvh]">
        <div
          className={`
        flex items-end md:items-center justify-center max-md:items-stretch w-full max-md:w-full min-h-full
        text-center !p-0
        `}
        >
          <div
            className={`
          relative max-md:flex max-md:flex-col
          bg-white text-left shadow-xl
          md:rounded-10 md:overflow-hidden
          transform transition-all
          max-md:w-full md:min-w-[520px] max-md:h-[100dvh] max-md:m-0
          `}
          >
            {header}
            {children}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

/**
 * A React hook that disables scrolling on the body element when a component
 * mounts, and re-enables it when the component unmounts.
 */
export function usePreventBodyScroll() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = 'hidden';
    document.body.classList.add('body-open-modal');
    document.getElementById('page').setAttribute('aria-hidden', true);

    return () => {
      document.body.style.overflow = originalStyle;
      document.getElementById('page').removeAttribute('aria-hidden');
    };
  }, []);
}
